import { useEffect, useState, useContext, useRef, useCallback } from "react";
import Breadcrumb from "../breacrumb/breadcrumb";
import PageHeader from "../../pageheader/PageHeader";
import styles from "./SearchPatient.module.css";
import { useNavigate } from "react-router-dom";
import { CurrentUserContext } from "../../../App";
import { RedirectCode400 } from "../../RedirectCode400";
import * as medicalApi from "../../../service/medicalApi";
import { BannerSearchSteps } from "./BannerSearchStep";
import Pagination from "../pagination/pagination";
import {
  status_list,
  datacolumns,
  datacolumnsDoctor,
  pathItems,
  checkStatus,
  formatDate,
  formatTime,
} from "./PatientComponent";
import ComboBoxV2 from "../../combobox/ComboBoxV2";
import { HashLoader } from "react-spinners";

function SearchPatient() {
  const navigate = useNavigate();
  const { setIsMessage } = useContext(CurrentUserContext);
  const auth = useRef(JSON.parse(localStorage.getItem("user")));

  // --- States ---
  const [data, setData] = useState([]);
  const [doctor, setDoctor] = useState([]);
  const [allDoctor, setAllDoctor] = useState([]);
  const [loading, setLoading] = useState(false);
  const [SendRequest, setSendRequest] = useState(false);
  const [SendData, setSendData] = useState(null);
  const [dataDate, setDataDate] = useState("");
  const [dataTime, setDataTime] = useState("");
  const [doctorData, setDoctorData] = useState("");
  const [status, setStatus] = useState("");
  const [inputID, setInputID] = useState("");
  const [inputName, setInputName] = useState("");
  const [inputLastName, setInputLastName] = useState("");
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(0);
  const [totalData, setTotalData] = useState(0);
  const [fieldErrors, setFieldErrors] = useState({
    pid: "",
    fname: "",
    lname: "",
  });
  const number_per_page = 10;

  const [searchTerm, setSearchTerm] = useState({
    id: "",
    fname: "",
    lname: "",
    status: "",
  });

  useEffect(() => {
    const errors = { pid: "", fname: "", lname: "" };
    let hasError = false;

    if (inputID && inputID.replace(/[^0-9]/g, "").length !== 13) {
      errors.pid = "กรุณาระบุเลขบัตรประจำตัวประชาชนให้ครบถ้วน";
      hasError = true;
    }
    if (inputName && inputName.trim().length < 3) {
      errors.fname = "กรุณาระบุชื่ออย่างน้อย 3 ตัวอักษร";
      hasError = true;
    }
    if (inputLastName && inputLastName.trim().length < 3) {
      errors.lname = "กรุณาระบุนามสกุลอย่างน้อย 3 ตัวอักษร";
      hasError = true;
    }

    setFieldErrors(errors);
    if (hasError) return; // ไม่ call API ถ้า error

    const timer = setTimeout(() => {
      setSearchTerm({
        id: inputID,
        fname: inputName,
        lname: inputLastName,
        status: status,
      });
      setPage(1);
    }, 600);

    return () => clearTimeout(timer);
  }, [inputID, inputName, inputLastName, status]);

  const showModal = () => {
    setSendRequest(!SendRequest);
  };

  let [personalInformation, setPersonalInformation] = useState("");

  useEffect(() => {
    const searchDataPatient = async () => {
      setLoading(true);

      let body = {
        status: searchTerm.status,
        pid: searchTerm.id,
        fname: searchTerm.fname,
        lname: searchTerm.lname,
        page,
        number_per_page,
      };

      let res;
      res = auth?.current?.auth?.role.includes("MEDICAL_PERSONNEL")
        ? await medicalApi.getDataPatient(body)
        : await medicalApi.getDataPatientByHospital(body);
      if (res) {
        if (res["data"]["code"] === 200) {
          if (res.data.patient_list) {
            setData(() => [
              ...res.data.patient_list.map((item) => ({
                no: item.no,
                IDCard: item.pid,
                UID: item.uid,
                Firstname: item.fname,
                Lastname: item.lname,
                Birthday: item.birthday,
                Age: item.age,
                Phonenumber: item.phone_number,
                Email: item.email,
                ...(auth?.current?.auth?.role.includes("MEDICAL_PERSONNEL")
                  ? {}
                  : {
                      Doctor: item.doctor ? item.doctor : "-",
                    }),
                Status: item.status,
                PermissionDate: item.accept_date,
                AccessPeriod: item.remaining_time,
                Action: item.action,
                credentialToken: item.credential_token,
              })),
            ]);
          }
          setMaxPage(Math.ceil(res["data"]["amount"] / 10));
          setTotalData(res["data"]["amount"]);
          setLoading(false);
        } else if (res["data"]["code"] === 403) {
          navigate(RedirectCode400());
          setLoading(false);
        } else if (res["data"]["code"] === 400) {
          setLoading(false);
          navigate("/doctor/ManageInfo", {
            state: {
              message: res["data"]["code"]["message_th"]
                ? res["data"]["code"]["message_th"]
                : "ระดับการพิสูจน์ตัวตนต่ำเกิน กรุณาเพิ่มระดับการพิสูจน์ตัวตน",
            },
          });
        } else {
          setLoading(false);
          setIsMessage({
            type: "error",
            data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
          });
        }
      }
    };

    searchDataPatient();
  }, [searchTerm, page, number_per_page, setIsMessage, navigate]);

  useEffect(() => {
    const searchGetDoctorList = async () => {
      let body = {
        doctor_fname: inputName,
        doctor_lname: inputLastName,
        hospital_id: auth.current?.hospital?.hospital_id,
      };
      let res = await medicalApi.getDataDoctorList(body);
      if (res) {
        if (res["data"]["code"] === 200) {
          if (res.data.doctor_list) {
            const lists = (res.data.doctor_list ?? []).map((data, index) => {
              return {
                ...data,
                fullName: `${data.fname} ${data.lname}`,
              };
            });
            setDoctor(lists);
          }
          setMaxPage(Math.ceil(res["data"]["amount"] / 10));
          setTotalData(res["data"]["amount"]);
        } else if (res["data"]["code"] === 403) {
          navigate(RedirectCode400());
        } else {
          setIsMessage({
            type: "error",
            data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
          });
        }
      }
    };

    const searchGetDoctorListAll = async () => {
      let res = await medicalApi.getDataDoctorListAll();
      if (res) {
        if (res["data"]["code"] === 200) {
          if (res.data.doctor_list) {
            const lists = (res.data.doctor_list ?? []).map((data, index) => {
              return {
                ...data,
                fullName: `${data.fname} ${data.lname}`,
              };
            });
            setAllDoctor(lists);
          }
          setMaxPage(Math.ceil(res["data"]["amount"] / 10));
          setTotalData(res["data"]["amount"]);
        } else if (res["data"]["code"] === 403) {
          navigate(RedirectCode400());
        } else {
          setIsMessage({
            type: "error",
            data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
          });
        }
      }
    };

    if (!auth === true) {
      navigate("/");
    } else if (
      !auth?.current?.auth?.role.includes("MEDICAL_PERSONNEL") &&
      !auth.current?.auth?.role.includes("HOSPITAL_PERSONNEL")
    ) {
      navigate("/");
    }

    if (auth.current?.auth?.role.includes("HOSPITAL_PERSONNEL")) {
      searchGetDoctorList();
      searchGetDoctorListAll();
    }
  }, [status, auth, navigate, inputLastName, inputName, setIsMessage]);

  const day = new Date().toLocaleDateString("th-TH", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= maxPage) {
      setPage(newPage);
    }
  };

  const handlerSelectDoctor = (e) => {
    setDoctorData(e.$value);
  };

  const SendRequestData = (data) => {
    const formatDate = new Date();
    const time =
      formatDate.toLocaleTimeString("th-TH", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      }) + " น.";

    const date = formatDate.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
    showModal();
    setSendData(data);
    setDataDate(date);
    setDataTime(time);
    setPersonalInformation(data.IDCard);
  };

  const clickResultLab = (credentialToken) => {
    navigate("/permission-lab-patient", {
      state: {
        credential_token: credentialToken,
      },
    });
  };

  const postRequestPermission = async (item) => {
    setSendRequest(!SendRequest);
    let res = "";
    res = await medicalApi.postRequestPermission(item.UID);
    if (res) {
      if (res["data"]["code"] === 200) {
        navigate("/search-for-patient-information", {});
        setIsMessage({ type: "success", data: "ส่งคำขอสำเร็จ" });
      } else if (res["data"]["code"] === 403) {
        navigate(RedirectCode400());
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  return (
    <>
      <div className="global-page !pb-0">
        <Breadcrumb pathItems={pathItems} />
        <PageHeader titlename="ค้นหาข้อมูลผู้ป่วย" />
        <div className="text-[1.2rem] my-6">
          ท่านสามารถค้นหาได้ 2 วิธี ทั้งจากการค้นหาด้วยหมายเลขบัตรประชาชน 13
          หลักและค้นหาด้วยชื่อและนามสกุล
        </div>
        <div className="flex flex-col gap-4">
          <div>
            <div className={styles.keyInput}>เลขบัตรประจำตัวประชาชน</div>
            <input
              value={inputID}
              onChange={(e) => setInputID(e.target.value)}
              type="text"
              placeholder="ระบุเลขบัตรประจำตัวประชาชน 13 หลักให้ครบถ้วน"
              maxLength="17"
              className={`${styles.input} w-[100%] max-w-[600px] md:w-full md:max-w-[100%]`}
              autoComplete="off"
              style={{ borderColor: fieldErrors.pid ? "red" : "" }}
            />
            {fieldErrors.pid && (
              <div className="text-red-500 text-sm mt-1">{fieldErrors.pid}</div>
            )}
          </div>
          <div className="flex flex-col">
            <div className={styles.keyInput}>ค้นหาชื่อและนามสกุล</div>
            <div className="flex gap-4 md:flex-col">
              <div className="w-[40%] md:w-[100%]">
                <div className={styles.keyInput}>ชื่อ</div>
                <input
                  value={inputName}
                  onChange={(e) => setInputName(e.target.value)}
                  type="text"
                  placeholder="ระบุชื่ออย่างน้อย 3 ตัวอักษร"
                  maxLength="17"
                  className={`${styles.input} w-[100%] max-w-[600px] md:w-full md:max-w-[100%]`}
                  autoComplete="off"
                  style={{ borderColor: fieldErrors.fname ? "red" : "" }}
                />
                {fieldErrors.fname && (
                  <div className="text-red-500 text-sm mt-1">
                    {fieldErrors.fname}
                  </div>
                )}
              </div>
              <div className="w-[40%] md:w-[100%]">
                <div className={styles.keyInput}>นามสกุล</div>
                <input
                  value={inputLastName}
                  onChange={(e) => setInputLastName(e.target.value)}
                  type="text"
                  placeholder="ระบุนามสกุลอย่างน้อย 3 ตัวอักษร"
                  maxLength="17"
                  className={`${styles.input} w-[100%] max-w-[600px] md:w-full md:max-w-[100%]`}
                  autoComplete="off"
                  style={{ borderColor: fieldErrors.lname ? "red" : "" }}
                />
                {fieldErrors.lname && (
                  <div className="text-red-500 text-sm mt-1">
                    {fieldErrors.lname}
                  </div>
                )}
              </div>
              <div className="flex flex-col justify-end w-[20%] md:w-[100%]">
                <button
                  className="flex justify-center items-center px-[20px] border border-[#42A1EF] bg-[#42A1EF] text-[#fff] h-[50px] rounded-md"
                  onClick={(e) => {
                    e.preventDefault();
                    // searchDataPatient();
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
                    <path d="M21 21l-6 -6" />
                  </svg>
                  <div className="ms-2">ค้นหา</div>
                </button>
              </div>
            </div>
          </div>
        </div>
        <PageHeader titlename="รายชื่อผู้ป่วยที่อนุญาตให้เข้าถึงข้อมูลทั้งหมด" />
        {loading ? (
          <div className="flex flex-col justify-center items-center h-40 w-full">
            <HashLoader color="#FF9768" size={70} />
            <div
              style={{
                marginTop: "20px",
                color: "#FF9768",
                fontWeight: "600",
                fontSize: "18px",
              }}
            >
              loading...
            </div>
          </div>
        ) : (
          <>
            <div className="w-full flex justify-between flex-wrap gap-2">
              <div className="flex">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                  <path d="M12 12l3 2" />
                  <path d="M12 7v5" />
                </svg>
                <div className="ms-2">ข้อมูลประจำวันที่: {day}</div>
              </div>

              <div className="flex flex-wrap gap-3">
                <div className="flex items-center me-2">
                  เลือกสถานะการเข้าถึงข้อมูล
                </div>

                <select
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                  className="border border-gray-500 rounded-md pl-[0.5rem] pr-[0.5rem] py-[0.5rem] cursor-pointer"
                >
                  {status_list.map((i) => (
                    <option value={i.value} key={i.value}>
                      {i.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="overflow-auto">
              <table className="w-full border-0 !bg-[#ffffff] rounded-xl">
                <thead>
                  <tr className="border-0">
                    {auth?.current?.auth?.role.includes("MEDICAL_PERSONNEL") ? (
                      <>
                        {datacolumns.map((dataHeader, index) => (
                          <th
                            key={index}
                            className="border-0 whitespace-nowrap"
                          >
                            {dataHeader.name}
                          </th>
                        ))}
                      </>
                    ) : (
                      <>
                        {datacolumnsDoctor.map((dataHeader, index) => (
                          <th
                            key={index}
                            className="border-0 whitespace-nowrap"
                          >
                            {dataHeader.name}
                          </th>
                        ))}
                      </>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 ? (
                    data.map((item, index) => (
                      <tr key={index} className="border-0">
                        <td className="border-0 whitespace-nowrap px-1">
                          {item.no}
                        </td>
                        <td className="border-0 whitespace-nowrap px-1">
                          {item.IDCard}
                        </td>
                        <td className="border-0 whitespace-nowrap px-1">
                          {item.Firstname}
                        </td>
                        <td className="border-0 whitespace-nowrap px-1">
                          {item.Lastname}
                        </td>
                        <td className="border-0 whitespace-nowrap px-1">
                          {item.Birthday}
                        </td>
                        <td className="border-0 whitespace-nowrap px-1">
                          {item.Age} ปี
                        </td>
                        <td className="border-0 whitespace-nowrap px-1">
                          {item.Phonenumber}
                        </td>
                        <td className="border-0 whitespace-nowrap px-1">
                          {item.Email || "-"}
                        </td>

                        {item.Doctor && (
                          <td className="border-0 whitespace-nowrap">
                            {item.Doctor || "ไม่มีหมอ"}
                          </td>
                        )}

                        <td className="border-0 whitespace-nowrap">
                          {checkStatus(item.Status)}
                        </td>
                        <td className="border-0 whitespace-nowrap">
                          {item.PermissionDate
                            ? formatDate(item.PermissionDate)
                            : "-"}
                        </td>
                        <td className="border-0 whitespace-nowrap">
                          {item.AccessPeriod
                            ? formatTime(item.AccessPeriod, "เวลาที่เหลือ")
                            : "-"}
                        </td>
                        <td className="border-0">
                          <div className="w-full flex justify-around gap-4">
                            <button
                              className={
                                item.Action
                                  ? styles.disabledBtn
                                  : styles.SendRequestBtn
                              }
                              onClick={
                                !item.Action
                                  ? () => {
                                      SendRequestData(item);
                                    }
                                  : undefined
                              }
                            >
                              ส่งคำขอ
                            </button>
                            {auth?.current?.auth?.role.includes(
                              "MEDICAL_PERSONNEL",
                            ) ? (
                              <button
                                className={
                                  item.Action
                                    ? styles.LabResultsBtn
                                    : styles.disabledBtn
                                }
                                onClick={
                                  item.Action
                                    ? () => {
                                        clickResultLab(item.credentialToken);
                                      }
                                    : undefined
                                }
                              >
                                ดูผลแลป
                              </button>
                            ) : null}
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={12} className="text-center">
                        ไม่พบข้อมูล
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="w-full flex justify-end">
              <Pagination
                firstOrder={() => handlePageChange(1)}
                endOrder={() => handlePageChange(maxPage)}
                clickForward={() => handlePageChange(page + 1)}
                clickBackward={() => handlePageChange(page - 1)}
              />
            </div>
            <div className="my-4">
              จำนวน <span className="text-[#288AEB]">{totalData}</span> รายการ
            </div>
          </>
        )}
      </div>
      <BannerSearchSteps />

      {/* modal */}
      {SendRequest && (
        <div className="fixed top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] z-[1002] bg-[#000] bg-opacity-[0.3] h-full w-full rounded-lg">
          <div className="w-full h-full flex justify-center items-center">
            <div className="bg-[#fff] w-[600px] flex flex-col items-center justify-center rounded-md p-[2rem] gap-4">
              <h3 className="text-[1.6rem] font-bold tracking-wider">
                กรุณายืนยันการทำรายการ
              </h3>
              <div>
                {/* <span>09:30 น. 28 Oct 2024</span> */}
                <span>
                  {dataTime} {dataDate}
                </span>
              </div>
              {auth?.current?.auth?.role.includes("HOSPITAL_PERSONNEL") ? (
                <div className="flex flex-col justify-center items-center w-[50%] text-[1.1rem]">
                  เลือกหมอ
                  <ComboBoxV2
                    itemsLists={doctor}
                    itemsAll={allDoctor}
                    index="uid"
                    option="fullName"
                    placeholder="เลือกแพทย์"
                    searchPlaceholder="กรอกชื่อแพทย์"
                    onChange={(e) => {
                      handlerSelectDoctor(e);
                    }}
                  />
                </div>
              ) : null}
              <div className="text-[1.1rem]">
                ต้องการขออนุญาตเข้าถึงข้อมูลผู้ป่วย
              </div>
              <div className="my-4 text-[1.2rem] text-[#FF7000]">
                {SendData.Firstname} {SendData.Lastname}
              </div>
              <div className="flex w-full justify-center gap-4">
                <button
                  className="flex justify-center items-center px-[20px] text-[#000] h-[50px] rounded-md w-[30%]"
                  onClick={() => {
                    showModal();
                  }}
                >
                  ปิด
                </button>

                {auth?.current?.auth?.role.includes("HOSPITAL_PERSONNEL") ? (
                  <button
                    className="flex justify-center items-center px-[20px] border border-[#42A1EF] bg-[#42A1EF] text-[#fff] h-[50px] rounded-md  w-[30%]"
                    onClick={() => {
                      if (Object.keys(doctorData).length === 0) {
                        showModal();
                        setIsMessage({
                          type: "warning",
                          data: "กรุณาเลือกหมอ",
                        });
                      } else {
                        navigate(
                          "/search-for-patient-information/IDcard-request-data",
                          {
                            state: {
                              doctor: doctorData,
                              id_card: personalInformation,
                            },
                          },
                        );
                      }
                    }}
                  >
                    หน้าถัดไป
                  </button>
                ) : (
                  <button
                    className="flex justify-center items-center px-[20px] border border-[#42A1EF] bg-[#42A1EF] text-[#fff] h-[50px] rounded-md  w-[30%]"
                    onClick={() => {
                      postRequestPermission(SendData);
                    }}
                  >
                    ขออนุญาต
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default SearchPatient;
